window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    /**
     * @type {import("swiper/types").SwiperOptions}
     */
    let config = {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 24,
      allowTouchMove: true,
      loop: true,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        1280: {
          slidesPerView: 5,
          slidesPerGroup: 1,
          loop: false,
          allowTouchMove: false,
        },
      },
      on: {
        breakpoint: function (swiper) {
          swiper.slideTo(0);
        },
      },
    };

    /**
     * @type {import("swiper/types").Swiper}
     */
    var logosCarousel = new Swiper(
      '.logos-carousel__carousel-wrapper.swiper',
      config,
    );
  });
});
